module.exports = "/timeclock/directives/clockInMap-a38cc8.html";